import React from 'react';
import { HeartIcon, ArrowRightIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function Closing() {
  return <section className="py-20 bg-gradient-to-b from-white to-[rgb(var(--color-neutral-100))]" data-id="element-84">
      <div className="max-w-4xl mx-auto px-6" data-id="element-85">
        <div className="text-center mb-12" data-id="element-86">
          <p className="text-lg text-[rgb(var(--color-neutral-800))] leading-relaxed mb-8" data-id="element-87">
            Wil je ontdekken of jouw hond ook zo enthousiast wordt van Anifit?
            Bestel een proefpakket en ervaar zelf het verschil. Kijk hoe je hond
            reageert op natuurlijke, soorteigen voeding zonder onnodige
            toevoegingen. Net als de hond van onze coach Amber en vele andere
            honden, kan jouw hond binnen enkele weken al positieve veranderingen
            laten zien.
          </p>

          <p className="text-xl font-semibold text-[rgb(var(--color-neutral-900))] mb-8" data-id="element-88">
            Je krijgt direct advies over de juiste overschakelmethode en
            persoonlijke begeleiding tijdens het hele proces.
          </p>
        </div>

        <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8 md:p-12 border-2 border-green-200 mb-12" data-id="element-89">
          <div className="flex flex-col items-center text-center" data-id="element-90">
            <div className="w-20 h-20 bg-gradient-to-br from-green-500 to-emerald-600 rounded-full flex items-center justify-center mb-6 shadow-lg" data-id="element-91">
              <HeartIcon className="w-10 h-10 text-white" data-id="element-92" />
            </div>

            <p className="text-2xl font-bold text-[rgb(var(--color-neutral-900))] mb-4" style={{
            fontFamily: 'Brush Script MT, cursive'
          }} data-id="element-93">
              Liefs,
            </p>
            <p className="text-xl font-semibold text-[rgb(var(--color-neutral-900))] mb-8" data-id="element-94">
              Amee & team
            </p>

            <div className="bg-white/80 backdrop-blur-sm p-6 rounded-xl border border-green-300 max-w-2xl" data-id="element-95">
              <p className="text-lg font-bold text-[rgb(var(--color-neutral-900))] mb-3" data-id="element-96">
                P.S.
              </p>
              <p className="text-[rgb(var(--color-neutral-800))] leading-relaxed" data-id="element-97">
                De darmen van je hond zijn het fundament van zijn gezondheid.
                Geef ze de aandacht die ze verdienen - je hond zal je er
                dankbaar voor zijn! En misschien verdwijnen die "onverklaarbare"
                lichamelijke of gedragsklachten sneller dan je denkt. Begin
                vandaag nog met de eerste stap naar een gezondere toekomst voor
                je trouwe vriend. <span className="text-2xl" data-id="element-98">🐾</span>
              </p>
            </div>
          </div>
        </div>

        {/* Final CTA */}
        <div className="bg-gradient-to-r from-[rgb(var(--color-secondary))] to-orange-600 text-white rounded-2xl p-8 text-center shadow-2xl" data-id="element-99">
          <p className="text-xl font-semibold mb-6" data-id="element-100">Klaar om te beginnen?</p>
          <Button variant="secondary" size="large" href="https://www.anifit.com/content/dierenvoeding/shop/shop/article/284379/proefpakket-hond" className="bg-white text-[rgb(var(--color-secondary))] hover:bg-gray-50" data-id="element-101">
            Bestel je proefpakket
            <ArrowRightIcon className="w-6 h-6 ml-2" data-id="element-102" />
          </Button>
        </div>
      </div>
    </section>;
}